module.exports = __webpack_public_path__ + "static/media/resourceF.52f0bf75.svg";